import { render, staticRenderFns } from "./CustomerProductPricingView.vue?vue&type=template&id=46f393e0&scoped=true"
import script from "./CustomerProductPricingView.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerProductPricingView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CustomerProductPricingView.vue?vue&type=style&index=0&id=46f393e0&prod&scoped=true&lang=css"
import style1 from "./CustomerProductPricingView.vue?vue&type=style&index=1&id=46f393e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f393e0",
  null
  
)

export default component.exports